module.exports = __webpack_public_path__ + "img/BlinkArt_Wand_Basic.5f989ff1.png";